import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import ApiService from '../../../../services/api';
import ExamManager from './exam_manager';
import '../../css/editor.css';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { toast } from "react-toastify";
import { confirmToast } from '../../../app/components/confirmToast';
import Expand from '../../../../media/expand.png';
import Collapse from '../../../../media/collapse.png';
import Full from '../../../../media/full_screen.png';
import Resize from '../../../../media/resize_screen.png';
import Text from '../../../../media/text.png';
import Video from '../../../../media/video.png';
import Scorm from '../../../../media/scorm.png';
import H5P from '../../../../media/h5p.png';
import Cancel from '../../../../media/cancel_2.png';
import CourseContent from '../../../../media/courses_content.png';
import Add from '../../../../media/add.png';
import Lesson from '../../../../media/play_lesson_2.png';
import Exam from '../../../../media/play_exam_2.png';
import Timer from '../../../../media/timer_3.png';
import Course from '../../../../media/courses.png';
import QuillEditor from '../../../../services/quill_editor';
import Back from '../../../../media/back.png';
import TinyMCEEditor from '../../../../services/tinymce';




function CreateModule() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [title, setTitle] = useState('');
  const [lessons, setLessons] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [expandedLessons, setExpandedLessons] = useState({});
  const [fullscreenLessonKey, setFullscreenLessonKey] = useState(null);
  const [activeTab, setActiveTab] = useState('lessons');
  const [deletedLessonIds, setDeletedLessonIds] = useState([]);
  const [deletedQuestionIds, setDeletedQuestionIds] = useState([]);
  const [deletedChoiceIds, setDeletedChoiceIds] = useState([]);
  const location = useLocation();
  const [courseTitle, setCourseTitle] = useState(location.state?.courseTitle || '');
  const courseSlug = location.state?.courseSlug || slug;
  


  const [exam, setExam] = useState({
    id: null,
    min_score_to_pass: '',
    num_questions: '',
    time_limit_minutes: '',
    questions: [],
    shuffle_questions: true,
    shuffle_choices: true,
  });


  useEffect(() => {
    const fetchCourseTitle = async () => {
      if (!courseTitle) {
        try {
          const course = await ApiService.getCourse(courseSlug);
          setCourseTitle(course.title);
        } catch (err) {
          console.error('Errore nel recupero del corso:', err);
        }
      }
    };

    fetchCourseTitle();
  }, [courseSlug, courseTitle]);

 

  const validateExam = (exam) => {
    const errs = {};

    const hasExamData =
      exam.questions.length > 0 ||
      exam.min_score_to_pass ||
      exam.num_questions;

    if (!hasExamData) return errs;

    const minScore = Number(exam.min_score_to_pass);
    const numQuestions = Number(exam.num_questions);
    const timeLimit = Number(exam.time_limit_minutes);

    if (!minScore || minScore <= 0 || minScore > 100) {
      errs.exam_min_score_to_pass =
        'Il punteggio minimo è obbligatorio e deve essere maggiore di 0 e non superiore a 100';
    }


    if (!numQuestions || numQuestions <= 0) {
      errs.num_questions =
        'Il numero delle domande è obbligatorio e deve essere maggiore di 0';
    }

    if (
      exam.time_limit_minutes !== "" &&
      (!timeLimit || timeLimit <= 0)
    ) {
      errs.time_limit_minutes =
        'Il limite di tempo deve essere maggiore di 0 (lascia vuoto per tempo illimitato)';
    }

    exam.questions.forEach((q, i) => {
      if (!q.question_text.trim()) {
        errs[`question_text_${i}`] =[
         "Testo della domanda obbligatorio", 
         true
        ];
      }

      if (
        q.type === 'multiple' &&
        (!q.choices || q.choices.length < 2)
      ) {
        errs[`choices_${i}`] = "Almeno 2 risposte richieste";
      }

      if (!q.choices || !q.choices.some(c => c.correct)) {
        errs[`correct_${i}`] = [
          '! Non hai selezionato una risposta corretta',
           true
        ];
      }

      q.choices?.forEach((c, ci) => {
        if (!c.choice_text.trim()) {
          errs[`choice_${i}_${ci}`] = [
            'Testo della risposta obbligatoria',
            true
          ]
        }
      });
    });

    return errs;
  };

  const validate = () => {
    const errs = {};

    if (!title.trim()) {
      errs.title = ['Titolo modulo obbligatorio', true]
    }

    lessons.forEach((lesson, i) => {
      if (!lesson.title.trim()) {
        errs[`lesson_title_${i}`] =  ['Titolo lezione obbligatorio', true]
      }

      if (
        lesson.completed_video !== null &&
        lesson.completed_video !== undefined
      ) {
        if (lesson.completed_video < 1 || lesson.completed_video > 100) {
          errs[`lesson_completed_video_${i}`] = [
            'Il valore deve essere tra 1 e 100',
            true
          ];
        }
      }
    });


    const examErrors = validateExam(exam);

    return { ...errs, ...examErrors };
  };

  const toggleLessonContent = (lessonId) => {
    setExpandedLessons(prev => ({
      ...prev,
      [lessonId]: !prev[lessonId],
    }));
  };


  
  const handleLessonChange = (index, field, value) => {
  setLessons(prev =>
    prev.map((lesson, i) => {
      if (i !== index) return lesson;

      let updatedLesson = { ...lesson, [field]: value };

     
      if (field === 'text_content') {
        if (value && lesson.media_file) {
          updatedLesson.media_file = null;
          updatedLesson.completed_video = null;
          updatedLesson.h5p_file = null;
        }
      }

      
      if (field === 'media_file') {
        if (value) {
          updatedLesson.text_content = '';
          updatedLesson.reading_ok = false;
          updatedLesson.h5p_file = null;

      
          if (value instanceof File) {
            updatedLesson.media_url = null;
          }

          
          if (typeof value === 'string') {
            updatedLesson.media_url = value;
            updatedLesson.completed_video = null;
          }
        }

        if (!value) {
          updatedLesson.completed_video = null;
        }
      }

      if (field === 'h5p_file') {
        if (value) {
          updatedLesson.text_content = '';
          updatedLesson.reading_ok = false;
          updatedLesson.media_file = null;
          updatedLesson.completed_video = null;
        }
      }

      return updatedLesson;
    })
  );
};


  const addLesson = () => {
    setLessons(prev => [
      ...prev,
      {
        tempId: 'temp-' + Date.now() + '-' + Math.floor(Math.random() * 1000),
        isNew: true,           
        contentType: null,
        title: '',
        text_content: '',
        media_file: null,
        media_url: null,
        h5p_file: null,
        reading_ok: false,
        completed_video: null,
      },
    ]);
  };

  const removeLesson = index => {
  setLessons(prev => {
    const lessonToRemove = prev[index];
    if (lessonToRemove.id) {
      setDeletedLessonIds(dl => {
        if (!dl.includes(lessonToRemove.id)) {
          return [...dl, lessonToRemove.id];
        }
        return dl; 
      });
    }
    return prev.filter((_, i) => i !== index);
  });
};

  const handleDragEnd = result => {
    if (!result.destination) return;
    setLessons(prev => {
      const items = Array.from(prev);
      const [moved] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, moved);
      return items.map((l, i) => ({ ...l, order: i }));
    });
  };

  
  const handleAttachmentChange = e => {
    const filesArray = Array.from(e.target.files);
    const newAttachments = filesArray
      .filter(f => !attachments.some(a => a.file?.name === f.name || a.file_url?.includes(f.name)))
      .map(f => ({ id: null, file: f, file_url: null }));

    setAttachments(prev => [...prev, ...newAttachments]);
  };

  const removeAttachment = async index => {
    const attToRemove = attachments[index];
    if (attToRemove.id) {
      try {
        await ApiService.deleteAttachment(attToRemove.id);
      } catch (err) {
        console.error(err);
        setErrorMessage('Errore nella rimozione di un allegato.');
        return;
      }
    }
    setAttachments(prev => prev.filter((_, i) => i !== index));
  };

 

  
  const handleSave = async () => {
    setSuccessMessage('');
    setErrorMessage('');
    setErrors({});

    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      setSaving(false); //
      return;
    }

    try {
      setSaving(true);
      const moduleResponse = await ApiService.newModule({
        title,
        course: slug,
      });

      const moduleSlug = moduleResponse.slug;

      for (const [index, lesson] of lessons.entries()) {
        const savedLesson = await ApiService.saveLesson(lesson, moduleSlug, index);
        setLessons(prev =>
          prev.map((l, i) =>
            i === index ? { ...l, id: savedLesson.id } : l
          )
        );
      }

      for (const att of attachments) {
        await ApiService.saveAttachment(att, moduleSlug);
      }

      let examId = null;

      if (exam.questions.length > 0) {
        const examRes = await ApiService.newExam({
          module: moduleSlug,
          min_score_to_pass: parseFloat(exam.min_score_to_pass),
          num_questions: parseInt(exam.num_questions, 10),
          time_limit_minutes: exam.time_limit_minutes
            ? parseInt(exam.time_limit_minutes, 10)
            : null,
          shuffle_questions: exam.shuffle_questions,
          shuffle_choices: exam.shuffle_choices,
        });
        examId = examRes.id;
      }

      if (examId) {
        for (const q of exam.questions) {
          const newQ = await ApiService.newQuestion({
            exam: examId,
            question_text: q.question_text,
          });

          for (const c of q.choices) {
            if (!c.choice_text.trim()) continue; 

            await ApiService.newChoice({
              question: newQ.id,
              choice_text: c.choice_text,
              correct: c.correct,
            });
          }
        }
      }

      toast.success(`Modulo ${title} creato con successo.`);
      navigate(`/admin/moduli/gestisci/${courseSlug}` , {state: {courseTitle, courseSlug},})
    } catch (err) {
      console.error(err);
      toast.error('Errore durante il salvataggio del modulo.');
    } finally {
      setSaving(false);
    }
  };


  
  return (
    <div className="editor-form">
      <h2><img src={CourseContent} alt="crea modulo " className="section-image" />Crea modulo</h2>
      <button
        className="tab-button"
        style={{marginTop:'20px'}}
        onClick={() => navigate(`/admin/moduli/gestisci/${slug}` , {state: {courseTitle, courseSlug},})}
        type='button'
      >
        <img src={Back} alt="Modifica" className="button-image" style={{marginTop:'-2.5px', marginRight:'2.5px'}}/>
        Torna all'elenco dei moduli
      </button>
      <p style={{marginTop:'50px'}} className='teacher-card2'><img src={Course} alt="" style={{width:'32px', height: '32px', marginTop:'-5px', marginRight: '10px'}} />Corso selezionato: {courseTitle}</p>

      

      
      <label>
        Titolo Modulo *
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          disabled={saving || deleting}
          className={`input ${errors.title ? "error" : ""}`}
          maxLength={250}
        />
        {errors.title && <span className='error'>{errors.title}</span>}
      </label>


      <div className="module-tabs">
        <button
          type="button"
          className={`tab-button ${activeTab === 'lessons' ? 'active' : ''}`}
          onClick={() => setActiveTab('lessons')}
        >
          <img src={Lesson}  alt="cancel" style={{ width: 24, height: 24,  marginTop: "-2.5px", marginRight:"5px"}} />
          Lezioni
        </button>

        <button
          type="button"
          className={`tab-button ${activeTab === 'exam' ? 'active' : ''}`}
          onClick={() => setActiveTab('exam')}
        >
          <img src={Exam}  alt="cancel" style={{ width: 24, height: 24,  marginTop: "-2.5px", marginRight:"5px"}} />
          Esame
        </button>
      </div>


      {activeTab === 'lessons' && (
      <>
      <h3>Lezioni</h3>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="lessons">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {lessons.map((lesson, index) => {
                
                const key = lesson.id || lesson.tempId;

                const isFullscreen = fullscreenLessonKey === key;

                return (
                  <Draggable key={key} draggableId={key.toString()} index={index}>
                    {(provided) => (
                      <div
                        className={`lesson-card ${isFullscreen ? 'lesson-fullscreen' : ''}`}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >

                        <div className="form-groupz">
                          {isFullscreen && (
                          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '30px'}}>
                            <button
                              type="button"
                              className="editor-form-reset"
                              onClick={() => setFullscreenLessonKey(null)}
                            >
                              <img
                                  className="extra-img"
                                  src={Resize}
                                  alt="Riduci"
                                />
                                <span className="toggle-text">
                                  Riduci finestra
                                </span>
                            </button>
                          </div>
                          )}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              {(lesson.contentType === 'text' || lesson.text_content) && <img src={Text} alt="Testo" style={{ width: 36, height: 36 }} />}
                              {(lesson.contentType === 'media' || lesson.media_file || lesson.media_url) && <img src={Video} alt="Video" style={{ width: 36, height: 36 }} />}
                              {(lesson.contentType === 'interactive' || lesson.h5p_file) && <img src={H5P} alt="Interattivo" style={{ width: 36, height: 36, borderRadius: '6px' }} />}
                            </div>

                            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                              {(lesson.contentType === 'text' || (lesson.text_content && !lesson.media_file && !lesson.media_url)) && (
                                <div className="form-groupz">
                                  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: "-2.5px", fontWeight: '400' }}>
                                    <input type="checkbox" checked={lesson.reading_ok} onChange={(e) => handleLessonChange(index, 'reading_ok', e.target.checked)} />
                                    <img src={Timer} alt="" style={{ width: 24, height: 24 }} />
                                    Abilita tempo di lettura lezione
                                  </label>
                                </div>
                              )}

                              {lessons.length > 0 && (
                                <button type="button" style={{ marginRight: "20px", borderRadius: "16px", padding: "10px" }} onClick={() => removeLesson(index)}>
                                  <img src={Cancel} alt="cancel" style={{ width: 24, height: 24, marginTop: "-2.5px" }} />
                                  Rimuovi lezione
                                </button>
                              )}
                            </div>
                          </div>
                        
                          <label>Titolo lezione:</label>
                          <input
                            type="text"
                            value={lesson.title}
                            onChange={(e) => handleLessonChange(index, 'title', e.target.value)}
                            className={`input ${errors[`lesson_title_${index}`] ? "error" : ""}`}
                            maxLength={250}
                          />
                          {errors[`lesson_title_${index}`] && (
                            <span className="error">{errors[`lesson_title_${index}`]}</span>
                          )}
                        </div>

                       
                        {lesson.isNew && !lesson.contentType && (
                          <div className="form-groupz">
                            <label>Tipo di lezione:</label>
                            <div>
                              <button
                                type="button"
                                className="editor-form-reset"
                                onClick={() => {
                                  handleLessonChange(index, 'contentType', 'text');
                                  setExpandedLessons((prev) => ({ ...prev, [key]: true }));
                                }}
                              >
                                <img src={Text} alt="text" style={{ width: 64,height: 64, marginRight: '5px' }} />
                                Testo
                              </button>
                              <button
                                type="button"
                                className="editor-form-reset"
                                onClick={() => {
                                  handleLessonChange(index, 'contentType', 'media');
                                  setExpandedLessons((prev) => ({ ...prev, [key]: true }));
                                }}
                              >
                                <img src={Video} alt="video" style={{ width: 64,height: 64, marginRight: '5px' }} />
                                Video
                              </button>
                              <button
                                type="button"
                                className="editor-form-reset"
                                onClick={() => {
                                  handleLessonChange(index, 'contentType', 'interactive');
                                  setExpandedLessons((prev) => ({ ...prev, [key]: true }));
                                }}
                              >
                                <img src={H5P} alt="interactive" style={{ width: 48,height: 48, borderRadius: '12px', marginRight: '5px' }} />
                                Interattivo
                              </button>
                            </div>
                          </div>
                        )}

                       
                        {(lesson.contentType || (!lesson.isNew && (lesson.text_content || lesson.media_file || lesson.media_url || lesson.h5p_file))) && (
                          <>
                            {!isFullscreen && (
                              <button
                                  type="button"
                                  className="toggle-lesson editor-form-reset"
                                  onClick={() => toggleLessonContent(key)}
                                >
                                  <img
                                    className="extra-img"
                                    src={expandedLessons[key] ? Collapse : Expand}
                                    alt="Riduci Espandi"
                                  />
                                  <span className="toggle-text">
                                    {expandedLessons[key] ? 'Riduci' : 'Espandi'}
                                  </span>
                                </button>
                            )}

                            <div
                              style={{
                                display: expandedLessons[key] ? 'block' : 'none',
                              }}
                            >

                              
                              {(lesson.contentType === 'text' || (lesson.text_content && !lesson.media_file && !lesson.media_url)) && (
                                <>
                                  <TinyMCEEditor
                                    value={lesson.text_content}
                                    onChange={(value) => handleLessonChange(index, 'text_content', value)}
                                    placeholder="Scrivi qui il contenuto della lezione..."
                                    expanded={true}
                                  />

                                </>
                              )}

                              
                              {(lesson.contentType === 'media' || (lesson.media_file || lesson.media_url)) && (
                                <>
                                  <div className="form-groupz">
                                    <label
                                      style={{
                                        display: "inline-block",
                                        padding: "10px 16px",
                                        background: "#393939",
                                        color: "white",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        marginTop: "20px"
                                      }}
                                    >
                                      + File video
                                      <input
                                        key={
                                          lesson.media_file instanceof File
                                            ? lesson.media_file.name
                                            : lesson.media_file || 'empty'
                                        }
                                        style={{ display: "none" }}
                                        type="file"
                                        accept="video/*"
                                        onChange={(e) =>
                                          handleLessonChange(index, 'media_file', e.target.files[0])
                                        }
                                      />
                                    </label>

                                    <div className="form-groupz" style={{ marginTop: "15px" }}>
                                      <label>URL video:</label>
                                      <input
                                        type="text"
                                        placeholder="https://..."
                                        value={typeof lesson.media_file === 'string' ? lesson.media_file : ''}
                                        onChange={(e) =>
                                          handleLessonChange(index, 'media_file', e.target.value)
                                        }
                                        className="input"
                                      />
                                    </div>

                                    {lesson.media_file && (
                                      <div className='attachstyle2' style={{ padding: "12.5px" }}>
                                        <p style={{ marginTop: '15px', marginLeft: '5px' }}>
                                          <img
                                            src={Video}
                                            alt=""
                                            style={{ width: '32px', height: '32px', marginTop: '-5px', marginRight: '10px' }}
                                          />

                                          {lesson.media_file instanceof File
                                            ? lesson.media_file.name
                                            : lesson.media_file}
                                        </p>

                                        <button
                                          type="button"
                                          onClick={() => handleLessonChange(index, 'media_file', null)}
                                          style={{ marginTop: "10px" }}
                                        >
                                          Rimuovi media
                                        </button>
                                      </div>
                                    )}
                                  </div>

                                  <div className="form-groupz">
                                  <label>Percentuale video completamento (1-100, opzionale):</label>

                                  <input
                                    type="number"
                                    min="1"
                                    max="100"
                                    value={lesson.completed_video || ''}
                                    disabled={typeof lesson.media_file === 'string'}
                                    className={`input ${errors[`lesson_completed_video_${index}`] ? "error" : ""}`}
                                    onChange={(e) =>
                                      handleLessonChange(
                                        index,
                                        'completed_video',
                                        e.target.value ? Number(e.target.value) : null
                                      )
                                    }
                                    onWheel={(e) => e.currentTarget.blur()}
                                  />

                                  {typeof lesson.media_file === 'string' && (
                                    <small style={{ color: '#888', display: 'block', marginTop: '5px' }}>
                                      Disponibile solo per file video caricati
                                    </small>
                                  )}

                                  {errors[`lesson_completed_video_${index}`] && (
                                    <span className="error">
                                      {errors[`lesson_completed_video_${index}`]}
                                    </span>
                                  )}
                                </div>
                                </>
                              )}
                              {(lesson.contentType === 'interactive' || (lesson.h5p_file)) && (
                                <>
                                  <label style={{
                                          display: "inline-block",
                                          padding: "10px 16px",
                                          background: "#393939",
                                          color: "white",
                                          borderRadius: "8px",
                                          cursor: "pointer",
                                          marginTop: "20px"
                                        }}>
                                    + File H5P
                                    <input
                                      style={{display: "none"}}
                                      type="file"
                                      onChange={(e) =>
                                        handleLessonChange(index, 'h5p_file', e.target.files[0])
                                      }
                                    />
                                    </label>
                                    {lesson.h5p_file && (
                                      <div className='attachstyle2' style={{padding: "12.5px"}}>
                                        <p style={{marginTop:'15px', marginLeft:'5px'}}><img src={H5P} alt="" style={{width:'32px', height: '32px', marginTop:'-5px', marginRight: '10px'}} />{lesson.h5p_file.name}</p>
                                      </div>
                                    )}
                                </>
                              )}
                            </div>
                          </>
                        )}

                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>


      <button
        type="button"
        onClick={addLesson}
        disabled={saving || deleting}
         style={{
    
        }}
      >
        <img src={Add} alt="aggiungi lezione" className="button-image2" />
        Aggiungi Lezione
      </button>

      <hr />
      </>
      )}


      {activeTab === 'exam' && (
      <ExamManager
         examData={exam}
          setExamData={setExam}
          deletedQuestionIds={deletedQuestionIds}
          setDeletedQuestionIds={setDeletedQuestionIds}
          deletedChoiceIds={deletedChoiceIds}
          setDeletedChoiceIds={setDeletedChoiceIds}
          saving={saving}
          errors={errors}
      />
      )}

      
        
        <div className='attachstyle'>
        
        
        <label style={{
          display: "inline-block",
          padding: "10px 16px",
          background: "#393939",
          color: "white",
          borderRadius: "8px",
          cursor: "pointer",
          marginTop: "0"
        }}>
          + Allegato
        <input
          type="file"
          accept="application/pdf"
          multiple
          onChange={handleAttachmentChange}
          disabled={saving || deleting}
          style={{display: "none"}}
        />
        </label>


        {attachments.map((att, index) => {
          let fileLink = '#';
          if (att.file_url) fileLink = att.file_url;
          else if (att.file instanceof File) fileLink = URL.createObjectURL(att.file);


          return (

            <div
              key={att.id || index}
              style={{
                backgroundColor: '#fff',
                borderRadius: '6px',
                
                marginBottom: '0.75rem',
              }}
            >
            
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding:'20px'
                }}
                className='attachstyle2'
              >
                <a
                  href={fileLink}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: '#393939',
                    textDecoration: 'none',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    maxWidth: '80%',
                  }}
                >
                  {att.file
                    ? att.file.name
                    : att.file_url
                    ? att.file_url.split('/').pop()
                    : 'File Allegato'}
                </a>

                <button
                  type="button"
                  onClick={() => removeAttachment(index)}
                  disabled={saving || deleting}
                >
                  <img src={Cancel}  alt="cancel" style={{ width: 16, height: 16}} />
                </button>
              </div>
              
            </div>
          );
        })}
        </div>

        
        <div
        style={{
          marginTop: '50px',
          display: 'flex',
          justifyContent: 'space-between',
          width:'14%',
          
        }}
      >
        <button
          type="button"
          onClick={handleSave}
          disabled={saving}
          style={{marginTop: "50px" }}
        >
          <img src={Add} alt="crea modulo" className="button-image2" />
          {saving ? 'Creazione in corso...' : 'Crea Modulo'}
        </button>
      </div>
    </div>
  );
}

export default CreateModule;